module.exports = __webpack_public_path__ + "img/253.03e0b706.jpg";